import { StateContext } from "@ngxs/store";

import { IStateProcessor } from "../state-processor";
import { AppDataStateModel } from "@shared/models/app-data.model";
import { NgxsStoreHelpers } from "@shared/stores/store.helpers";
import { CommonSearchCriteria } from "@shared/models/common-data.model";
import { DefaultTeamMessageModel } from "@app/shared/models/team-message.model";

export class TeamMessageStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return DefaultTeamMessageModel.search.searchForm.model.searchCriteria;
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) {
    NgxsStoreHelpers.SetTeamMessageSearchCriteria(ctx, searchCriteria);
  }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) {
    var currentSearchCriteria = ctx.getState().teamMessage.search.searchForm.model.searchCriteria;
    this.SetSearchCriteria(ctx, [...newSearchCriteria, ...currentSearchCriteria]);
  }
}
